/**
 * Size limits for evidence of work (40759). A newly attached file goes to the API as base64 inside the save, so
 * the API caps each save request at 110,000,000 bytes: 75 MB of new files once base64 has grown them by a third.
 * Files already stored go back by reference and do not count.
 */
export const MAX_EVIDENCE_FILE_BYTES = 50 * 1024 * 1024;
export const MAX_EVIDENCE_NEW_BYTES_PER_SAVE = 75 * 1024 * 1024;

export const EVIDENCE_SIZE_HINT = 'Try a lower-resolution photo or a compressed PDF.';

/** Shown when the API refuses a save as too large (HTTP 413). */
export const EVIDENCE_TOO_LARGE_MESSAGE =
  'The files attached are too large to save. Each file can be up to 50 MB, and the files attached in one save ' +
  `up to 75 MB in total. ${EVIDENCE_SIZE_HINT}`;
